import tw, { styled } from 'twin.macro';

export const DetailsBackdrop = styled.div`
  ${tw`
    fixed
    inset-0
    z-40
    flex
    items-center
    justify-center
    px-6
    py-6
  `}
  background: rgba(0, 0, 0, 0.7);
`;

export const DetailsContent = styled.div`
  ${tw`
    w-full
    max-w-6xl
    rounded-2xl
    overflow-hidden
    shadow-xl
  `}
  background: rgba(15, 15, 15, 0.95);
  backdrop-filter: blur(6px);

  @media (max-width: 900px) {
    max-width: 95vw;
  }
`;

export const DetailsHeader = styled.div`
  ${tw`
    relative
    p-6
    min-h-[16rem]
    flex
    items-end
  `}
  background: ${(props) => (
    props.backgroundUrl
      ? `linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.85) 70%), url('${props.backgroundUrl}')`
      : '#111'
  )};
  background-size: cover;
  background-position: center;

  @media (max-width: 900px) {
    padding: 1.25rem;
    min-height: 12rem;
  }
`;

export const DetailsTopActions = styled.div`
  ${tw`
    absolute
    left-8
    top-6
    flex
    items-center
    gap-2
  `}
`;

export const DetailsActionButton = styled.button`
  ${tw`
    text-sm
    font-semibold
    px-4
    py-2
    rounded-full
  `}
  background: ${(props) => (props.$primary ? '#f5f5f5' : 'rgba(255, 255, 255, 0.15)')};
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: ${(props) => (props.$primary ? '#111' : '#fff')};
  cursor: pointer;
`;

export const DetailsClose = styled.button`
  ${tw`
    absolute
    top-5
    right-5
    text-white
    text-lg
    font-bold
    w-9
    h-9
    rounded-full
    flex
    items-center
    justify-center
  `}
  border: none;
  background: rgba(0, 0, 0, 0.6);
  cursor: pointer;
`;

export const DetailsTitle = styled.h2`
  ${tw`
    text-4xl
    font-bold
  `}

  @media (max-width: 900px) {
    font-size: 2rem;
  }
`;

export const DetailsHeaderMeta = styled.div`
  ${tw`
    mt-3
    flex
    items-center
    gap-3
    text-base
    font-semibold
  `}
  span:first-child {
    color: #46d369;
  }
`;

export const DetailsBody = styled.div`
  ${tw`
    p-6
    grid
    gap-6
  `}

  @media (max-width: 900px) {
    padding: 1.25rem;
  }
`;

export const DetailsSplit = styled.div`
  ${tw`
    p-6
    grid
    gap-6
  `}
  grid-template-columns: minmax(0, 1fr) 16rem;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    padding: 1.25rem;
  }
`;

export const DetailsMeta = styled.div`
  ${tw`
    text-sm
    text-gray-300
    space-y-3
  `}
`;

export const DetailsMetaRight = styled(DetailsMeta)`
  ${tw`
    text-left
  `}
  padding-left: 0;
`;

export const DetailsMetaItem = styled.div`
  ${tw`
    leading-relaxed
  `}
`;

export const DetailsSubtitle = styled.h3`
  ${tw`
    px-6
    pb-2
    text-lg
    font-semibold
  `}
`;

export const DetailsRow = styled.div`
  ${tw`
    pr-2
    pb-4
    space-y-3
    max-h-64
    overflow-y-auto
  `}
`;

export const DetailsRowItem = styled.div`
  ${tw`
    flex
    items-center
    gap-4
    cursor-pointer
    py-1
  `}
  img,
  video {
    ${tw`
      rounded-lg
      object-cover
    `}
    width: ${(props) => (props.$variant === 'landscape' ? '7.5rem' : '5rem')};
    height: ${(props) => (props.$variant === 'landscape' ? '4.25rem' : '7.5rem')};
  }
`;

export const DetailsRowIndex = styled.span`
  ${tw`
    text-gray-400
    w-6
  `}
`;

export const DetailsRowText = styled.div`
  ${tw`
    text-sm
    text-gray-200
    flex
    flex-col
  `}
  span {
    ${tw`
      text-gray-400
    `}
  }
`;
